import { AutoSuggestItem } from "../../AutoSuggestResponse";
import EntityType from "../../EntityType";

export const buildGetItemUrl = (teamId: string): string => {
  return `/api/v1/teams/${teamId}?withBreadcrumbs=true`;
};

export const buildSuggestItem = (getItemResponse: any): AutoSuggestItem => {
  const teamData = getItemResponse.data;
  return {
    urlId: teamData.teamId,
    title: teamData.name,
    detail: teamData.breadcrumbs
      .map((breadcrumb: any) => breadcrumb.name)
      .join(" > "),
    type: EntityType.TEAM,
  };
};

export const getIdFromSuggestItem = (suggestItem: AutoSuggestItem): string => {
  return suggestItem.urlId;
};
